import authHelper from 'api/auth/helper'

import * as mutationTypes from 'store/mutationTypes'
import * as actions from './actions'

export default {
  state: {
    loggedIn: !!authHelper.getAuthToken(),
    loggedInError: null,
  },
  actions,
  mutations: {
    [mutationTypes.LOGIN_SUCCESS]: (state) => {
      state.loggedIn = !!authHelper.getAuthToken()
    },
    [mutationTypes.LOGOUT_SUCCESS]: (state) => {
      state.loggedIn = false
    },
  },
}



// WEBPACK FOOTER //
// ./src/store/modules/auth/index.js